export enum HttpStatusCodes {
  Accepted = 202,
  BadRequest = 400,
  Conflict = 409,
  Created = 201,
  InternalServerError = 500,
  NoContent = 204,
  NotFound = 404,
  NotImplemented = 501,
  OK = 200,
  ResetContent = 205,
  Unauthorized = 401,
  Forbidden = 403,
}
